<script>
import {mapGetters} from "vuex";
import AnalyticsDetailRow from "@/components/MultiConnect/Analytics/AnalyticsDetailRow.vue";
import Loading from "@/components/Loading.vue";

export default {
  name: "ConnectionsAnalytics",
  components: {Loading, AnalyticsDetailRow},
  props: {
    isPdf: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    ...mapGetters(["currentEvent"]),
    noOfConnectionRequested() {
      return this.currentEvent.analyticsData.totalConnectionRequested.toLocaleString();
    },
    noOfConnectionMade() {
      return this.currentEvent.noOfConnections.toLocaleString();
    }
  },
  methods: {
    view() {
      this.$router.push({
        name: "connectionAnalytics",
        params: {
          eventId: this.currentEvent.id,
      }});
    }
  }
}
</script>

<template>
  <div>
    <v-card :outlined="isPdf ? false : true" :height="isPdf ? 260 : 220">
      <v-card-title>Connections</v-card-title>
      <div>
<!--        <v-divider/>-->
        <div class="px-4 pb-4">
          <AnalyticsDetailRow title="Attendees that sent requests" :value="noOfConnectionRequested" @onView="view"
                              :show-view-button="true"
                              :subtitle="!isPdf ? '' : 'This total reflects the number of attendees that sent connection requests.'"
                              :tooltip="isPdf ? '' : 'This total reflects the number of attendees that sent connection requests.'"/>
          <v-divider/>
          <AnalyticsDetailRow title="Connections made" :value="noOfConnectionMade" @onView="view"
                              :show-view-button="true"
                              :subtitle="!isPdf ? '' : 'The Connections made reflects the total number of accepted connection requests'"
                              :tooltip="isPdf ? '' : 'The Connections made reflects the total number of accepted connection requests'"/>
        </div>
      </div>
    </v-card>
  </div>
</template>

<style scoped>

</style>